import { Component } from '@angular/core';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import * as accounting from 'accounting';

@Component({
  selector: 'app-cell-amount',
  templateUrl: './cell-amount.component.html',
  styleUrls: ['./cell-amount.component.less'],
})
export class CellAmountComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }

  formatterAmount(value: number): string {
    if(value == null || isNaN(value)) {
      return null;
    }
    else if (value === 0) {
      value = 0;
    }

    if (value === null || isNaN(value)) {
      value = 0;
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.AmountDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }
}
